<template>
  <div>
    <van-nav-bar
      :title="title"
      fixed
      placeholder
      @click-right="$emit('rc')"
      z-index="999"
    >
      <template #left>
        <van-tag
          size="large"
          :class="gBtnRound() && 'radius-1rem'"
          v-if="!sGetConfig('kioskMode')"
          >{{ sPotype }}</van-tag
        >
        <van-tag
          size="large"
          plain
          v-bind:text-color="sGetConfig('color2')"
          :class="gBtnRound() ? 'bg-white radius-1rem' : 'bg-white'"
          ><i class="el-icon-s-order" />{{ getTblid() }}</van-tag
        >
      </template>
      <template #right>
        <div v-if="!sGetConfig('kioskMode')">
          <div class="C2"><i class="el-icon-menu" /> 查詢</div>
        </div>
        <div v-if="sGetConfig('kioskMode')">
          <div class="C2"><i class="el-icon-menu" /> 管理</div>
        </div>
      </template>
    </van-nav-bar>
  </div>
</template>
<style scoped>
.el-button {
  margin: 0;
  color: v-bind(sGetConfig("color2"));
}
.van-tag {
  background-color: v-bind(sGetConfig("color2"));
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  border-radius: 0;
  margin-right: 0.3rem;
}
.van-icon {
  color: v-bind(sGetConfig("color2"));
}
i {
  color: v-bind(sGetConfig("color2"));
}
.radius-1rem {
  border-radius: 1rem;
}
.bg-white {
  background-color: white;
}
.pr-12 {
  padding-right: 12px;
}
</style>
<script>
export default {
  props: {
    title: String,
    l: String,
    r: String,
    type: String,
  },
  data() {
    return {};
  },
  methods: {
    getTblid() {
      if (this.sPotype == "內用") {
        if (this.sPassCode) {
          return this.sTblid;
        }
        return this.sPhone;
      }
      return this.sPhone;
    },
  },
};
</script>
